module.exports = __webpack_public_path__ + "static/TommyBahama2-9c728dee16ac139ca99f99695879e4bb.png";